import React from 'react';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { debounce } from 'lodash';


function CKEditorComman({ onContentChange, content }) {

    const handleEditorChange = debounce((event, editor) => {
        const data = editor.getData();
        if (submitCount > 0) {
            let validationErrors = ValidateFields({ ...states, content: data });
            validationErrors = ErrorFilter(validationErrors, requireField);
            setErrors(validationErrors);

            if (Object.keys(validationErrors)?.length === 0) {
                delete errors["content"];
            }
        }
        setStates({ ...states, content: data });
        onContentChange(data);
    }, 300); // Adjust debounce time as needed

    const editorConfiguration = {
        extraPlugins: [CustomAdapterPlugin],
        mediaEmbed: {
            previewsInData: true,
        },

        toolbar: {
            items: [
                "undo",
                "redo",
                "|",
                "heading",
                "|",
                "bold",
                "italic",
                "link",
                "|",
                "bulletedList",
                "numberedList",
                "|",
                "blockQuote",
                // "|",
                // "imageUpload",
                // "|",
                // "mediaEmbed",
                // "|",
                // "imageTextAlternative",
                // ... any other toolbar items except 'insertTable'
            ],
        },

        image: {
            toolbar: [
                "imageStyle:full",
                "imageStyle:side",
                "|",
                "imageTextAlternative",
            ],
            resizeUnit: "px",
        },
    };

    function CustomAdapterPlugin(editor) {
        editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
            return new CustomUploadAdapter(loader); // Ensure this matches your import
        };
    }


    const submitCount = 0; // Example value for submitCount
    const states = []; // Example value for states
    const errors = []; // Example value for errors

    // Define or import necessary functions
    const ValidateFields = () => {
        // Your implementation of ValidateFields function
    };

    const ErrorFilter = () => {
        // Your implementation of ErrorFilter function
    };

    const requireField = () => {
        // Your implementation of requireField function
    };

    const setErrors = () => {
        // Your implementation of setErrors function
    };

    const setStates = () => {
        // Your implementation of setStates function
    };

    class CustomUploadAdapter {
        constructor(loader) {
            this.loader = loader;
        }
        upload() {

        }
        abort() {
            // Abort the upload process if necessary
        }
    }

    return (
        <>
            <CKEditor
                editor={ClassicEditor}
                data={content}
                onChange={handleEditorChange}
                config={editorConfiguration}
            />

        </>
    )
}

export default CKEditorComman